/**
 * login
 */

export default [{
  name: 'customKeyPage',
  path: '/customKeyPage',
  meta: {
    title: '自定义字段管理',
    href: '/customKeyPage',
    isTab: true,
    redirect: 'noredirect'
  },
  component: () => import( /* webpackChunkName: 'customKeyPage' */ '@/views/customKeyPage'),
},
];
